import {connect} from 'react-redux'

import userUtil from '../util/user.util'
import {Contact} from './contact.component'


const mapStateToProps = (state) => {
    return {
  	currentUser: userUtil.getCurrentUser(state)
    }
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

const ContactContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Contact)

export default ContactContainer